import * as Recharts from 'recharts';

export class XAxis extends Recharts.XAxis {
  static defaultProps = {
    ...Recharts.XAxis.defaultProps,
    padding: { left: 10, right: 10 },
    tickMargin: 12,
    minTickGap: 70,
    domain: ['dataMin', 'dataMax'],
  };
}
